import moment from 'moment';
import momentTimezone from 'moment-timezone';
import React, { useContext, useState } from 'react';
import { getStockArrangementReport } from '../../../api/report';
import Header from '../../../Components/Header/Header';
import ReactTable from '../../../Components/Table/Table';
import { AppContext } from '../../../Context/AppContext';
import { MODULES, DEFAULT_TIMEZONE } from './../../../Helpers/Constants';
import { getAccessByModuleName } from './../../../Routes/Routes';
import styles from './index.module.scss';
import { setAllStore } from 'Helpers/setAllStore';
import GlobalDateFilters from 'Components/GlobalDateFilters/GlobalDateFilters';
const MostPorpularProduct = () => {
  const { showToastMessage, modules } = useContext(AppContext);
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [defaultFilter, setDefaultFilter] = React.useState({
    pageIndex: 0,
    pageSize: 10,
    sortBy: [],
    filters: [],
    globalFilter: '',
  });
  let storeTimezone = localStorage.getItem("storeTimezone") || DEFAULT_TIMEZONE;
  let defaultStartDate = moment()
    .subtract(7, 'days')
    .startOf('day')
    .format('ddd MMM DD, YYYY');
  let defaultEndDate = momentTimezone.tz(storeTimezone).startOf("day").format("ddd MMM DD, YYYY");
  const [fromDate, setFromDate] = useState(defaultStartDate);
  const [toDate, setToDate] = useState(defaultEndDate);

  const [pageCount, setPageCount] = React.useState(1);

  const [checkAllStore,setCheckAllStore] = useState(true);

  const handleClearSearch = async (event) => {
    event.preventDefault();
    setFromDate(defaultStartDate);
    setToDate(defaultEndDate);
    fetchData({
      ...defaultFilter,
      fromDateDefault: defaultStartDate,
      toDateDefault: defaultEndDate,
    });
  };

  // Date Validation
  const dateValidation = (fromDate, toDate) => {
    let startDate = moment(fromDate).format('x');
    let endDate = moment(toDate).format('x');
    if (startDate > endDate) {
      showToastMessage(
        undefined,
        'Start date should not be greater than from end date',
        'error',
        false
      );
      return false;
    }
    let daysDiff = moment(fromDate).diff(toDate, 'days');
    daysDiff = daysDiff < 0 ? daysDiff * -1 : daysDiff;
    if (daysDiff > 7) {
      showToastMessage(
        undefined,
        'Maximum 7 days is availabel',
        'error',
        false
      );
      return false;
    }
    return true;
  };

  const fetchData = async ({
    pageIndex,
    pageSize,
    sortBy,
    globalFilter,
    filters,
    fromDateDefault,
    toDateDefault,
  }) => {

    /*
      # when all store checkbox is checked at that time we set page_wise_all_store_checkbox=0 in local storage & this logic write in setAllStore function
      
    */
      setAllStore(checkAllStore);

    if (
      !dateValidation(
        fromDateDefault ? fromDateDefault : fromDate,
        toDateDefault ? toDateDefault : toDate
      )
    ) {
      return false;
    }
    let startDate = fromDateDefault ? fromDateDefault : fromDate;
    startDate = moment(startDate).format('YYYY-MM-DD');
    let endDate = toDateDefault ? toDateDefault : toDate;
    endDate = moment(endDate).format('YYYY-MM-DD');
    setDefaultFilter({ pageSize, pageIndex, filters, globalFilter, sortBy });
    setLoading(true);
    const postData = {
      currentPage: pageIndex,
      itemsPerPage: pageSize,
      globalSearch: globalFilter,
      filters,
      sortBy,
      start_date: startDate,
      end_date: endDate,
    };

    let accountAccess = getAccessByModuleName(
      modules,
      MODULES.STOCK_ARRANGEMENTS_REPORT
    );
    if (accountAccess && accountAccess.permissions.read_access) {
      const response = await getStockArrangementReport(postData);
      if (response && response.status === 200) {
        setData(response.data.data.rows);
        // setPageCount(Math.ceil(response.data.data.count.length / pageSize));
        setPageCount(Math.ceil(response.data.data.count / pageSize));
      } else {
        showToastMessage(undefined, response?.data?.message, 'error', false);
      }
    } else {
    }
    setLoading(false);

    //when the all store checkbox is checked and we get all store data(after the API call) then we set the selected store id=dropdown selected store in local storage and this logic writes in setAllStore  function
    if(checkAllStore){ setAllStore(false) }
  };

  const columns = React.useMemo(() => [
    {
      Header: 'Products',
      accessor: 'product_id',
      isVisible: true,
      disableFilters: true,
      disableSortBy: true,
      Cell: ({ value, row, column }) => {
        let defaultIndex = 0;
        row.original.product.product_images.forEach((d, i) => {
          if (d.is_default_selected) defaultIndex = i;
        });
        return (
          <div className="row">
            <div className={`col-md-4 ${styles.ProducatImageWapper}`}>
              <img
                height="70"
                width="60"
                src={
                  row.original.product.product_images.length === 0 ||
                  row.original.product.product_images[defaultIndex].image ===
                    '' ||
                  row.original.product.product_images[defaultIndex].image ===
                    'null' ||
                  row.original.product.product_images[defaultIndex].image ===
                    null
                    ? ''
                    : `${row.original.product.product_images[defaultIndex].image}`
                }
                alt=""
              />
            </div>
          </div>
        );
      },
    },
    {
      Header: 'Products Name',
      accessor: 'title',
      disableSortBy: true,
      isVisible: true,
      Cell: ({ value, row, column }) => {
        return `${row.original.product ? row.original.product.title : ''}`;
      },
    },
    {
      Header: 'Variation',
      accessor: 'variation_title',
      isVisible: true,
      disableSortBy: true,
      Cell: ({ value, row, column }) => {
        return row.original.title;
      },
    },
    {
      Header: 'Quantity',
      accessor: 'no_of_orders',
      isVisible: true,
      disableFilters: true,
    },
  ]);

  return (
    <div>
      <Header title="Stock Arrangements Report" />
      <div className="row mb-5">
        <div className="col-12 m-0 p-0">
          <GlobalDateFilters
            isDateFilter
            isSearchIcon
            isClearSearchBtn
            isAllCheckStoreBnt
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
            fetchData={()=>fetchData({
              ...defaultFilter
            })}
            handleClearSearch={handleClearSearch}
            checkAllStore={(data)=>{setCheckAllStore(data)}}
            defaultSetCheckAllStore={checkAllStore}
            key={"stock-arrangements-report"}
          />
        </div>
      </div>
      <div>
        <ReactTable
          columns={columns}
          data={data}
          loading={loading}
          fetchData={fetchData}
          pageCount={pageCount}
          defaultFilter={defaultFilter}
          noDataText={'There is no data to display'}
          displayGlobalSearch={false}
          displayColumnVisibility={false}
          displayLastColumnSorting={true}
        />
      </div>
    </div>
  );
};
export default MostPorpularProduct;
